import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=c027ec8a&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c027ec8a",
  null
  
)

export default component.exports